module.exports = __webpack_public_path__ + "static/img/yx2.7aa4c28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yx2.jpg
// module id = mYV5
// module chunks = 1